module.exports = __webpack_public_path__ + "img/to_tutorial.acfa052e.png";